export const LIST_PAGINATION_MIN_PAGE_SIZE = 10;
export const LIST_PAGINATION_DEFAULT_PAGE_SIZE = 10;
export const LIST_PAGINATION_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;
